import BusinessFunds from "./BusinessFunds";

export default BusinessFunds;
